import React from "react";
import { dishes } from "../data/dishes";
import { faqs } from "../data/faqs";
import { useTheme, useDocumentTitle } from "../hooks/useSite";
import FaqList from "../components/FaqList";
import { Host } from "../illustrations";

export default function FaqPage() {
  useTheme(dishes[0]);
  useDocumentTitle("FAQs");
  return (
    <>
      <section className="ro-faq-intro">
        <div className="ro-container ro-split ro-faq-intro__split">
          <div>
            <h1>
              <strong className="ro-italic">The</strong>
              <br />
              <span className="ro-outline ro-outline--light">FAQs</span>
            </h1>
            <p>From your next craving to finding your way here, a few useful answers about RollOver.</p>
            <p>But wait… there’s more!</p>
            <p>Here are some questions you might ask before your next café break.</p>
          </div>
          <Host className="ro-faq-intro__host" />
        </div>
      </section>
      <section className="ro-section">
        <div className="ro-container ro-faq-wrap">
          <FaqList items={faqs} />
        </div>
      </section>
    </>
  );
}
